import fetch from './api'

// 获取用户登录信息
const GETUSERINFO = params => {
    return fetch({
        url: '/api/admin/base/getLoginUserInfoBySession',
        method: 'get',
        params: params
    })
}


// /signout/logout/signout

// 用户退出
const SIGNOUT = params => {
    return fetch({
        url: '/api/signout/logout/signout',
        method: 'get',
        params: params
    })
}
// 获取媒资平台秘钥
const GETBAIDUVIDEOTOKEN = params => {
  return fetch({
    url: '/api/admin/library/getBaiduVideosToken',
    method: 'get',
    params
  })
}
// 获取OSS平台秘钥
const GETOSSTOKEN = params => {
  return fetch({
    url: '/api/getOssToken',
    method: 'get',
    params
  })
}
// 获取七牛平台秘钥
const GETQINIUTOKEN = params => {
  return fetch({
    url: '/api/admin/library/qiniuToken',
    method: 'get',
    params
  })
}
// 创建媒资
const MEDIACREATE = params => {
  return fetch({
    url: '/api/admin/library/createQiniuMedia',
    method: 'POST',
    data: params
  })
}
// 获取媒资播放地址
const GETMEDIAURL = params => {
  return fetch({
    url: '/api//admin/library/getReferUrl',
    method: 'GET',
    params
  })
}
// 查询mediaID是否存在
const CHECKMEDIAID = params => {
  return fetch({
    url: '/api/admin/library/checkMediaId',
    method: 'get',
    params
  })
}


export default {
    GETUSERINFO,
    SIGNOUT,
    GETBAIDUVIDEOTOKEN,
    GETOSSTOKEN,
    GETQINIUTOKEN,
    CHECKMEDIAID,
    MEDIACREATE,
    GETMEDIAURL
}



// WEBPACK FOOTER //
// ./src/api/interface-user.js